<template>
  <div>
    <el-dialog
      :visible="isShow"
      :title="titleText"
      width="1000px"
      class="partShipment"
      @close="handelClose"
    >
      <p>产品信息</p>
      <el-table
        v-loading="loading"
        :data="detailInfo.productList"
        border
        style="width: 100%;margin-top:10px;margin-bottom:10px"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="itemIndex" label="序号" align="left" width="100" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" width="150" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" width="150" />
        <el-table-column prop="productName" label="物品名称" align="left" width="230" />
        <el-table-column prop="productNum" label="数量" align="left" width="70" />
        <el-table-column v-if="isNotOnlyHzdh" prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="100" />
        <el-table-column v-if="isNotOnlyHzdh" prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="100" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="150" />
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="150" />
      </el-table>

      <div class="advanceMakeDeatail">
        <div class="baseInfoForm">
          <h3>原信息</h3>
          <div class="rj-row">
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收货地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ detailInfo.primaryReceiptAddress }}
                </div>
              </div>
            </div>
          </div>

          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运输方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ detailInfo.primaryModelOfShipping }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  承运商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ detailInfo.primaryCarrier }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>变更后信息</h3>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后收货地址：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.receiptAddress }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后运输方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.modeOfShipping }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后承运商：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.carrier }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否需要唛头：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.markType }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              授权邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.authorizationEmail }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收货回执及到货验收要求：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.receiptArrivalAcceptanceRequirements }}
            </div>
          </div>
        </div>
      </div>

      <!-- <h4>关于收货回执及到货验收要求的内容</h4> -->
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              回执附件：
            </div>
            <div class="rj-baseinfo__item receipt-file-list">
              <el-link
                v-for="(item,index) in fileList"
                :key="index"
                class="receipt-file-link"
                :underline="false"
                style="color:#409EFF"
                @click="fileClick(item)"
              >
                {{ item.fileName }}
              </el-link>
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发货备注说明：
            </div>
            <div class="rj-baseinfo__item deliver-remark-text">
              {{ detailInfo.deliverRemark }}
            </div>
          </div>
        </div>
      </div>

      <!-- <h4>关于发货备注的说明内容</h4> -->
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注：
            </div>
            <div class="rj-baseinfo__item">
              {{ detailInfo.remark }}
            </div>
          </div>
        </div>
      </div>

      <h3>历史审批意见</h3>
      <el-table :data="tableList" border style="width: 100%;margin-top:10px;margin-bottom:10px">
        <el-table-column prop="approveUserInfo" label="审批人" align="left" width="170" />
        <el-table-column prop="approveComment" label="审批内容" align="left" />
        <el-table-column prop="approveTime" label="审批时间" align="left" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handelClose">关 闭</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>
<script type="es6">
import { partialInvoiceDetail, getReceiptAttachmentByPartialShipmentNum, attachmentGetToken, getApproveLogByPartialId } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    typeId: {
      type: String,
      default: 'id'
    }
  },

  data () {
    return {
      isShow: false,
      loading: false,
      deliveryNum: '',
      detailInfo: {},
      tableList: [],
      fileList: [],
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: '',
      isNotOnlyHzdh: true // 通过回执单号进来的弹窗，需要隐藏掉价格等关键信息
    };
  },

  computed: {
    titleText () {
      if (this.deliveryNum) {
        return `${this.title}（${this.deliveryNum}）`;
      } else if (this.title) {
        return this.title;
      } else {
        return '查看发货单信息';
      }
    }
  },

  methods: {
    initData (row) {
      this.loading = true;
      this.getTableDataHistory(row);
      partialInvoiceDetail({
        id: row[this.typeId]
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.loading = false;
          this.initFileData(data.deliveryNum);
          this.detailInfo = {
            ...data,
            markType: data.markType ? '是' : '否',
            receiptAddress: `${data.receiptAddress.province}${data.receiptAddress.city}${data.receiptAddress.county}`
          };
        } else {
          this.loading = false;
        }
      }).catch(e => {
        this.loading = false;
      });
    },

    // 获取回执附件列表
    initFileData (value) {
      getReceiptAttachmentByPartialShipmentNum({ partialShipmentNum: value }).then((res) => {
        const { data, status } = res.data;
        if (status === '200') {
          this.fileList = data || [];
        }
      });
    },

    getTableDataHistory (row) {
      getApproveLogByPartialId({ partialId: row.id }).then((res) => {
        const { data, status } = res.data;
        if (status === '200') {
          this.tableList = data || [];
        }
      });
    },

    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    // 文件服务器地址
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },

    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },

    openDialog (row, isNotOnlyHzdh = true) {
      this.deliveryNum = row.deliveryNum;
      this.isNotOnlyHzdh = isNotOnlyHzdh;
      this.initData(row);
      this.initToken();
      this.isShow = true;
    },

    handelClose () {
      this.isShow = false;
      this.detailInfo = {};
      this.tableList = [];
      this.fileList = [];
      this.isNotOnlyHzdh = true;
      this.$emit('handle-close');
    }
  }
};
</script>
<style scoped>
.partShipment p{
  margin: 10px 0 ;
}
.partShipment p span{
  display:inline-block;
  margin-right: 10px;
}
.receipt-file-list {
  display: block;
}

.receipt-file-link {
  display: block;
  width: fit-content;
  line-height: 22px;
}

.receipt-file-link + .receipt-file-link {
  margin-top: 4px;
}

.deliver-remark-text {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 22px;
}
</style>
